import { useLang } from "hooks/useLang"

const ToggleButtons = ({ tab, setCurrent, setPast }) => {
    const { t } = useLang()

    return (
        <div className="flex justify-center gap-5 md:justify-start">
            <button
                onClick={setCurrent}
                className={`w-[80px] rounded-md py-2 text-sm ${
                    tab === "current"
                        ? "bg-action-theme-200 text-white dark:bg-action-theme-400"
                        : "bg-gray-100 text-black dark:opacity-30"
                }`}>
                {t("current")}
            </button>
            <button
                onClick={setPast}
                className={`w-[80px] rounded-md py-2 text-sm ${
                    tab === "past"
                        ? "bg-action-theme-200 text-white dark:bg-action-theme-400"
                        : "bg-gray-100 text-black dark:opacity-30"
                }`}>
                {t("past")}
            </button>
        </div>
    )
}
export default ToggleButtons
